// Redux Action Types
import { SET_SETTINGS } from '../actions/types';
// Initial State
const initialState = false;

export default function (state = initialState, action) {
  if (action.type === SET_SETTINGS) return action.payload;
  return state;
}
